import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading } from 'components/Heading/Heading';
import { BackgroundImage } from 'components/Image/BackgroundImage';
import { Section } from 'components/Section/Section';
import { StarRating } from 'components/StarRating/StarRating';
import { deepExtract } from 'helpers/deep';
import { Image, RES } from 'models/Image';

export const MAX_SHOWABLE_VENUES = 20;
export const MIN_SHOWABLE_VENUES = 6;

export class VerticalVenueList extends Component {
  constructor(...args) {
    super(...args);
    this.renderVenueItem = this.renderVenueItem.bind(this);
  }

  state = {
    showMaxNumItems: false,
  };

  handleLoadMore = () => {
    this.setState({ showMaxNumItems: true });
  };

  renderVenueItem(element) {
    const { showCount } = this.props;
    const imgUrl = Image.getImage(element?.images, RES.low);
    const locationName = deepExtract('location.name', element);
    const ratingMean = deepExtract('ratings.mean', element);
    const hasRating = ratingMean > 0;
    const activities = deepExtract('activities', element);
    const ratingCount = deepExtract('ratings.display_total', element);

    return (
      <li className="mb" key={element.id}>
        <a href={`/studios/${element.alias}`}>
          <Section className="vertical-venue-list__item">
            <BackgroundImage extraBackgroundClass="vertical-venue-list__item__image" url={imgUrl} />
            <div className="vertical-venue-list__item__content">
              <Heading className="vertical-venue-list__item__title">{element.name}</Heading>
              {hasRating && (
                <StarRating
                  showRatingNumber={!showCount}
                  rating={ratingMean}
                  count={showCount && ratingCount && `${ratingCount} ratings`}
                />
              )}
              {locationName && <p className="vertical-venue-list__item__content__location mb-">{locationName}</p>}
              {activities && (
                <p className="vertical-venue-list__item__content__activities text--light">
                  {activities.split(',')[0].trim()}
                </p>
              )}
            </div>
          </Section>
        </a>
      </li>
    );
  }

  render() {
    const { elements } = this.props;
    const { showMaxNumItems } = this.state;
    const numItems = showMaxNumItems ? MAX_SHOWABLE_VENUES : MIN_SHOWABLE_VENUES;
    const canShowLoadMore = !showMaxNumItems && elements.length > MIN_SHOWABLE_VENUES;
    return (
      <div className="vertical-venue-list">
        <ul>{(elements || []).slice(0, numItems).map(this.renderVenueItem)}</ul>
        {canShowLoadMore && (
          <div className="vertical-venue-list__load-more" onClick={this.handleLoadMore}>
            <FormattedMessage id="vertical-venue-list.load.more" defaultMessage="Load more" />
          </div>
        )}
      </div>
    );
  }
}

VerticalVenueList.propTypes = {
  elements: PropTypes.array,
  showCount: PropTypes.bool,
};
